import * as React from "react";
import Component from "../../AbstractComponent";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";


export default class PersonDetailsEditable extends Component {
	public state = {
		
	};

  constructor(public props) {
    super(props);
	}
	
  public render() {
		const person: PersonInterface = this.props.person;
		
		return (
			<React.Fragment>
				<div className="charge-summary">
					<div style={{display: "flex", justifyContent: "space-between", alignItems: "flex-start"}}>
						<div style={{marginRight: "7px", fontSize: "17px", fontWeight: "bold"}}>
							{this.props.user ? this.trans("label-user") : this.trans("label-person")}
						</div>
					</div>
					<div style={{display: "flex", justifyContent: "space-between", alignItems: "baseline"}}>
						<div className="counterparty">
							{`${person?.displayName}`}
						</div>
					</div>
				</div>
				{this.props.editableFields}
			</React.Fragment>
		);
  }
}
